export default __webpack_public_path__ + "static/media/google.f582bf59.svg";